import { RootStore } from '../../../data/store'

export const returnBankListMappedData = (bankId: string) => {
  let selectedBank: any = {}
  RootStore.settings.metaData.bankList.map((item: any) => {
    if (item?.id === bankId) {
      selectedBank = item
    }
  })
  return selectedBank
}
